import { createTheme } from '@mui/material/styles';

const getCssVars = (mode) => {
  const isDark = mode === 'dark';
  return {
    '--app-bg': isDark
      ? 'radial-gradient(circle at top, #1e1b4b 0%, #020617 60%)'
      : 'radial-gradient(circle at top, #e0e7ff 0%, #f8fafc 60%)',
    '--surface-1': isDark
      ? 'linear-gradient(180deg, rgba(255,255,255,0.12), rgba(255,255,255,0.03))'
      : 'linear-gradient(180deg, rgba(255,255,255,0.9), rgba(248,250,252,0.8))',
    '--surface-2': isDark
      ? 'linear-gradient(135deg, rgba(99,102,241,0.2), rgba(14,165,233,0.12))'
      : 'linear-gradient(135deg, rgba(59,130,246,0.18), rgba(14,165,233,0.12))',
    '--surface-3': isDark ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.04)',
    '--border-subtle': isDark ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.12)',
    '--text-primary': isDark ? '#ffffff' : '#0f172a',
    '--text-secondary': isDark ? 'rgba(255,255,255,0.8)' : 'rgba(15,23,42,0.75)',
    '--text-muted': isDark ? 'rgba(255,255,255,0.6)' : 'rgba(15,23,42,0.6)',
    '--text-dim': isDark ? 'rgba(255,255,255,0.5)' : 'rgba(15,23,42,0.5)',
    '--table-header-bg': isDark ? 'rgba(15,23,42,0.65)' : 'rgba(15,23,42,0.06)',
    '--row-hover-bg': isDark ? 'rgba(255,255,255,0.06)' : 'rgba(15,23,42,0.04)',
    '--input-bg': '#ffffff',
    '--navbar-bg': isDark
      ? 'linear-gradient(180deg, rgba(2,6,23,0.92) 0%, rgba(15,23,42,0.9) 100%)'
      : 'linear-gradient(180deg, rgba(248,250,252,0.95) 0%, rgba(241,245,249,0.9) 100%)',
    '--drawer-bg': isDark
      ? 'linear-gradient(180deg, rgba(2,6,23,0.98) 0%, rgba(15,23,42,0.98) 100%)'
      : 'linear-gradient(180deg, rgba(248,250,252,0.98) 0%, rgba(241,245,249,0.98) 100%)',
    '--icon-button-bg': isDark ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.06)',
    '--icon-button-border': isDark ? 'rgba(255,255,255,0.12)' : 'rgba(15,23,42,0.12)',
    '--icon-button-hover-bg': isDark ? 'rgba(255,255,255,0.16)' : 'rgba(15,23,42,0.12)',
    '--glow-a': isDark
      ? 'radial-gradient(circle, rgba(56,189,248,0.35), rgba(2,6,23,0))'
      : 'radial-gradient(circle, rgba(59,130,246,0.18), rgba(248,250,252,0))',
    '--glow-b': isDark
      ? 'radial-gradient(circle, rgba(99,102,241,0.35), rgba(2,6,23,0))'
      : 'radial-gradient(circle, rgba(99,102,241,0.18), rgba(248,250,252,0))',
  };
};

export const createAppTheme = (mode = 'dark') =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: mode === 'dark' ? '#60a5fa' : '#2563eb',
      },
      background: {
        default: mode === 'dark' ? '#020617' : '#f8fafc',
        paper: mode === 'dark' ? '#0f172a' : '#ffffff',
      },
      text: {
        primary: mode === 'dark' ? '#ffffff' : '#0f172a',
        secondary: mode === 'dark' ? 'rgba(255,255,255,0.8)' : 'rgba(15,23,42,0.75)',
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ':root': {
            colorScheme: mode,
          },
          body: {
            minHeight: '100vh',
            background: 'var(--app-bg)',
            color: 'var(--text-primary)',
            transition: 'background 200ms ease, color 200ms ease',
            ...getCssVars(mode),
          },
        },
      },
    },
  });
